import React from 'react';
import { toast } from 'react-toastify';
import { notifyError } from './notifications';
import i18n from '../i18n';

import differenceInMilliseconds from 'date-fns/differenceInMilliseconds';
import { END_OF_SESSION_NOTIFY_MS } from 'utils/constants/timeConstants';
import { Column } from 'components/UIComponents/Layout';
import Button from 'components/UIComponents/Button';
import { logUserOutRequest, refreshSession } from '../api/authService';

let sessionNotificationTimer;
let sessionTimer;

const clearTimers = () => {
  clearTimeout(sessionNotificationTimer);
  clearTimeout(sessionTimer);
};

const Container = props => <div>{props.children}</div>;

const notification = () => (
    <Container>
      <Column>
        {i18n.t('datagate.external.auth.message.sessionExtend', {
          time: Math.round(END_OF_SESSION_NOTIFY_MS / 60000),
        })}
        <div className="ml-5 mt-2">
          <Button
              className="is-primary button mr-5 ml-5 is-small"
              onClick={() => {
                extendSession();
                toast.dismiss();
              }}
          >
            {i18n.t('datagate.external.global.yes')}
          </Button>
          <Button
              className="is-primary is-outlined button is-small ml-5"
              onClick={() => {
                logOutUser();
                toast.dismiss();
              }}
          >
            {i18n.t('datagate.external.global.no')}
          </Button>
        </div>
      </Column>
    </Container>
);

const extendSession = async () => {
  try {
    const {authenticated, expiresAt} = await refreshSession();
    localStorage.setItem('authenticated', authenticated);
    localStorage.setItem('expiresAt', expiresAt);
    onRefreshSessionSuccess();
  } catch (error) {
    notifyError(i18n.t('datagate.external.auth.message.error'), {
      killer: true,
    });
    logOutUser();
  }
};

const logOutUser = () => {
  logUserOutRequest();
};

export const onRefreshSessionSuccess = () => {
  clearTimers();
  const expiresAt = localStorage.getItem('expiresAt');

  if (expiresAt) {
    const expiresAtDate = new Date(expiresAt);
    const timeUntilEndOfSession = differenceInMilliseconds(
        expiresAtDate,
        new Date()
    );

    let timeUntilNotification =
        timeUntilEndOfSession - END_OF_SESSION_NOTIFY_MS;

    if (timeUntilNotification < 0) {
      timeUntilNotification = 1000;
    }

    sessionNotificationTimer = setTimeout(() => {
      toast.warning(notification(), {
        position: toast.POSITION.TOP_CENTER,
        theme: 'colored',
        autoClose: END_OF_SESSION_NOTIFY_MS,
        closeButton: false,
        closeOnClick: false,
      });
    }, timeUntilNotification);

    sessionTimer = setTimeout(() => {
      notifyError(i18n.t('datagate.external.auth.message.expired'), {
        killer: true,
      });
      logOutUser();
    }, timeUntilEndOfSession);
  }
};

// export const handleAuthEvent = (event, error) => {
//   switch (event) {
//     case 'onInitError':
//     case 'onAuthError':
//       clearTimers();
//       notifyError(i18n.t('datagate.external.auth.message.error'), {
//         killer: true,
//       });
//       console.error('authEvent', event, error);
//       break;
//     case 'onAuthRefreshError':
//       clearTimers();
//       notifyError(i18n.t('datagate.external.auth.message.expired'), {
//         killer: true,
//       });
//       console.error('authEvent', event, error);
//       break;
//     case 'onAuthSuccess':
//     case 'onAuthRefreshSuccess':
//       onAuthRefreshSuccess();
//       break;
//     default:
//       break;
//   }
// };
